/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const endpoint = project.getFeature(feature.getSettingValue('ENDPOINT'));
    if (!endpoint) {
        return blocks;
    }
    let links = project.getNodeLinks(feature, 'http_requested');
    const PATH = endpoint.getSettingValue('PATH');

    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        blocks.push({
            location: `HTTP_ENDPOINT_REQUESTED_${PATH}`,
            blockType: BlockType.CODE,
            id: `node_${link.getSourceId()}`,
            template: `'****${link.getSourceId()}****'`,
        });
    }

    return blocks;
};
